import { RSAA } from 'redux-api-middleware';
import getSocialPlatformsURL from 'url-constructors/getSocialPlatformsURL';
import { Dispatch } from 'redux';
import { TGetRootState, TDispatchResult } from 'types/shared';

const REQUEST = 'opus/social/REQUEST';
const SUCCESS = 'opus/social/SUCCESS';
const FAILURE = 'opus/social/FAILURE';

type SocialActionTypes = typeof REQUEST | typeof SUCCESS | typeof FAILURE;

interface ISocalAction {
  type: SocialActionTypes;
  payload: any;
}

interface ISocialState {
  loading: boolean;
  success: boolean;
  error: Error | null;
  errorInfo: any;
  data: any;
}

const initialState: ISocialState = {
  loading: false,
  success: false,
  error: null,
  errorInfo: null,
  data: null,
};

export default function reducer(
  state: ISocialState = initialState,
  action: ISocalAction
): ISocialState {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        errorInfo: null,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: new Error(action.payload.error),
        errorInfo: action.payload.errorInfo,
      };

    default:
      return state;
  }
}

/**
 * Load social platforms from the '/api/social/platforms' endpoint.
 *
 * @see https://github.com/agraboso/redux-api-middleware
 */
export const loadSocial = (): any => ({
  [RSAA]: {
    types: [
      REQUEST,
      SUCCESS,
      {
        type: FAILURE,
      },
    ],
    endpoint: getSocialPlatformsURL(),
    method: 'GET',
    credentials: 'same-origin',
  },
});

export const shouldLoadSocial = (): TDispatchResult<boolean> => {
  return (_: Dispatch, getState: TGetRootState): boolean => {
    const {
      social: { loading, data },
    } = getState();

    return !data && !loading;
  };
};
